import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

const Container = styled.div<{ scrolled: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  height: 60px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ scrolled }) => scrolled && "box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3)"};
  z-index: 100;
`;

const metlabMenu = styled.div`
  padding: 0 20px;

  @media (min-width: 640px) {
    padding: 0px;
  }
`;

const metlabDropdown = styled.div`
  width: 40em;
`;

const metlabDropdownMenuItem = styled.div`
  max-width: 55rem;

  @media (max-width: 1280px) {
    display: flex;
    flex-direction: column;
    max-width: 30rem;
    max-height: 32rem;
    overflow: auto;
  }
`;

const subItemIcon = styled.div`
  span:before {
    background-color: red !important;
  }
`;

const Logo = styled(GatsbyImage)`
  height: 50px;
  width: 50px;
`;

//

const S = {
  Container,
  metlabMenu,
  metlabDropdown,
  metlabDropdownMenuItem,
  subItemIcon,
  Logo,
};

export default S;
